import { render, staticRenderFns } from "./single-service.vue?vue&type=template&id=5ae9850e&scoped=true&"
import script from "./single-service.vue?vue&type=script&lang=js&"
export * from "./single-service.vue?vue&type=script&lang=js&"
import style0 from "./single-service.vue?vue&type=style&index=0&id=5ae9850e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae9850e",
  null
  
)

export default component.exports